import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
} from "./actionTypes"

const initialState = {
  user: JSON.parse(localStorage.getItem("user")) || null, // Load user from storage

  token: localStorage.getItem("authToken") || null,
  loading: false,
  error: null,
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return {
        ...state,
        loading: true,
      }
    case LOGIN_SUCCESS:
      localStorage.setItem("authToken", action.payload.token)

      // Set email from action.payload.user.email, fallback to existing localStorage email
      if (action.payload.user?.email) {
        localStorage.setItem("email", action.payload.user.email)
      }

      localStorage.setItem("user", JSON.stringify(action.payload.user))

      return {
        ...state,
        loading: false,
        user: action.payload.user,
        token: action.payload.token,
        email: action.payload.user?.email || state.email,
        error: null,
      }

    case LOGOUT_USER:
      return { ...state }

    case LOGOUT_USER_SUCCESS:
      localStorage.removeItem("authToken")
      return {
        ...state,
        user: null,
        token: null,
        email: null,
      }
    case API_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    default:
      return state
  }
}

export default authReducer
